import { FormikValues } from 'formik';
import React, { useRef, useEffect } from 'react';

import { Card } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateProduct } from '../Product.hooks';
import { Product } from '../Product.interface';

const ProductDescriptionCard: React.FC<{
  product: Product;
  onChange?: (product: Product) => void;
}> = ({ product, onChange }) => {
  const { description } = product;
  const formikRef = useRef<FormikValues>();
  const onChangeRef = useRef(onChange);
  const {
    updatedProduct,
    isUpdating,
    updateError,
    updateProduct
  } = useUpdateProduct(product.id);
  const { isFieldDisabled } = useTaskEntityFields(product.task);
  useEffect(
    () => void (updatedProduct && onChangeRef.current?.(updatedProduct)),
    [updatedProduct]
  );
  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Product Description
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={updateError}
          isSubmitting={isUpdating}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ description: description || '' }}
          onSubmit={(dto: Partial<Product>) => {
            updateProduct(dto);
          }}
        >
          <InlineForm>
            <InlineTextField
              name='description'
              label='Product Description'
              placeholder='Enter Product Description'
              multiline={true}
              disabled={isFieldDisabled('description')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default ProductDescriptionCard;
